export function getOsName(): string {
  const ua = navigator.userAgent;
  if (ua.includes('Windows')) {
    return 'Windows';
  }

  if (ua.includes('Android')) {
    return 'Android';
  }

  if (/iPhone|iPad|iPod/.test(ua)) {
    return 'iOS';
  }

  if (ua.includes('Mac OS X')) {
    return 'Mac OS';
  }

  if (ua.includes('Linux')) {
    return 'Linux';
  }

  return 'Unknown';
}
